import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Cargar todos los tanques según parámetros del cliente para una empresa en especifico.
 *
 * @param {*} { commit }: store del módulo.
 * @param {*} { product, company_id, number_tank, locations_id, volume_unit_id, locations_id }: parámetros.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function getTanks({ commit }, { product, company_id, number_tank, locations_id, volume_unit_id, page, per_page }) {
  commit('resetDataFilter')
  commit('setLoadingDataTable', true)
  commit('resetTableConfig')

  const params = configParamsUrl({ product, number_tank, locations_id, volume_unit_id });

  await $http.get(`signaling-of-tanks/reports/get-tanks?company_id=${company_id}&page=${page}&perPage=${per_page}`, { params } )
    .then(({ data: response }) => {

      if (typeof response.data === 'object' && 'data' in response.data) {
        commit('setTableConfig', {
          items: response.data.data,
          data: response.data
        })
      }

    })
    .catch(errors => {

      // Errores de validaciones
      if (controlErrorsCallback(errors)) return false;

      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Señalización de tanques',
        text: 'Ups, ocurrió un error al tratar de genera el reporte de tanques por empresa.',
        showConfirmButton: true,
      })

    })
    .finally(() => commit('setLoadingDataTable', false));
}

/**
 * Cargar todos los tanques según parámetros del cliente para una empresa en especifico.
 *
 * @param {*} { commit }: store del módulo.
 * @param {*} { product, company_id, number_tank, locations_id, volume_unit_id, locations_id }: parámetros.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function exportToExcelDataTanks({ commit }, { product, company_id, number_tank, locations_id, volume_unit_id }) {
  commit('resetDataFilter')
  commit('setLoadingDownloadReport', true)

  const params = configParamsUrl({ product, number_tank, locations_id, volume_unit_id });

  await $http.get(`signaling-of-tanks/reports/export-tanks-to-excel?company_id=${company_id}`, { params })
    .then(({ data: response }) => {

      if (typeof response.data === 'object' && 'file' in response.data) 
        downloadFileCallback({ fileName: response.data.fileName, file: response.data.file })

    })
    .catch(errors => {

      // Errores de validaciones
      if (controlErrorsCallback(errors)) return false;

      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Señalización de tanques',
        text: 'Ups, ocurrió un error al tratar de genera el reporte de tanques por empresa.',
        showConfirmButton: true,
      })

    })
    .finally(() => commit('setLoadingDownloadReport', false));
}

/**
 * Controlar los errores de validaciones del filtro.
 *
 * @param {object} errors
 * @returns {boolean}
 * @author Fernando Claros
 */
function controlErrorsCallback(errors) {
  try {

    if ('data' in errors && typeof errors.data === 'object' && errors.status == 400) {

      let errorsText = "<ul><li style='list-style: none;'>Algunos de los parámetros enviados son inválidos.</li>";
      Object.values(errors.data).forEach(item => errorsText += `<li style='font-size: 16px;' class='text-left;'><i>${item}</i></li>`);
      errorsText += "</ul>";

      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Señalización de tanques',
        html: errorsText,
        showConfirmButton: true
      });

      return true;
    }

    return false;

  } catch (e) {
    return false;
  }
}

/**
 * Configurar los parámetros del filtro para asi mismo enviarlos.
 *
 * @param { product, number_tank, locations_id, volume_unit_id }: parámetros
 * @returns {Object}
 * @author Fernando Claros
 */
function configParamsUrl({ product, number_tank, locations_id, volume_unit_id }) {
  // Configurar ruta para agregar parámetros
  const params = new URLSearchParams();
  // Nombre del producto
  if (product) params.append('product', product);
  // Número del tanque
  if (number_tank) params.append('number_tank', number_tank);
  // Id de las ubicaciones
  if (typeof locations_id === 'object') {
    if (locations_id.length > 0) locations_id.map(id => params.append('locations_id[]', id))
  }
  // Id de las unidades de medida
  if (typeof volume_unit_id === 'object') {
    if (volume_unit_id.length > 0) volume_unit_id.map(id => params.append('volume_unit_id[]', id))
  }
  
  return params;
}

/**
 * Fabricantes - Descargar archivo con todos los registros
 *
 * @param {String} fileName: nombre el archivo a descargar
 * @param {base64} file: archivo a descargar. Este llega en formato base64
 * @returns {Promise<void>}
 */
function downloadFileCallback({ fileName, file }) {
  try {
    
    let linkTemporary = document.createElement("a");
    document.body.appendChild(linkTemporary);

    linkTemporary.setAttribute("type", "hidden");
    linkTemporary.href = "data:text/plain;base64," + file;
    linkTemporary.download = fileName;
    linkTemporary.click();

    document.body.removeChild(linkTemporary);

  } catch (e) {

    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'Señalización de tanques',
      text: 'Ups, ocurrió un error al tratar de genera el reporte de tanques.',
      showConfirmButton: true,
    })

  }
}